<script setup lang="ts">
import FileUploadZone from '@/components/ui/file-upload/FileUploadZone.vue';

defineProps<{
  taskId: string;
}>();
</script>

<template>
  <section>
    <div class="mb-3">
      <p class="text-base font-semibold text-foreground">Uploads</p>
      <p class="text-sm text-muted-foreground">Keep task files in one place for quick access.</p>
    </div>
    <FileUploadZone
      entity-type="task"
      :entity-id="taskId"
      title="Files"
      empty-text="No task files uploaded yet."
    />
  </section>
</template>
